"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoggerBuilder = getLoggerBuilder;
exports.getLogger = getLogger;

var _ConsoleLogger = require("./ConsoleLogger");

var _Builder = require("./Builder");

function getLoggerBuilder() {
  return new _Builder.LoggerBuilder(_ConsoleLogger.buildConsoleLogger);
}

function getLogger() {
  return getLoggerBuilder().build();
}
//# sourceMappingURL=index.js.map